import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import StudentPortal from "./pages/StudentPortal";
import BoardPortal from "./pages/BoardPortal";
import AdminPortal from "./pages/AdminPortal";
import "./index.css";

function PrivateRoute({ children, role }) {
  const { currentUser, userRole } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  if (role && userRole !== role) return <Navigate to="/login" />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* tamutrip.com front door for the August and November board meetings; August's own landing lives at /august. */}
          <Route path="/" element={<Home />} />
          <Route path="/august" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/student" element={<PrivateRoute role="student"><StudentPortal /></PrivateRoute>} />
          <Route path="/board" element={<PrivateRoute role="board"><BoardPortal /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute role="admin"><AdminPortal /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
